<template>
  <VSpinner />
</template>

<script>
import VSpinner from '@/components/Spinner';
import subscriptionBegin from '@/views/Substore/Product/subscriptionBegin';

export default {
  name: 'OrderAccount',

  comments: {
    VSpinner,
  },

  props: {
    subscriptionTemplateId: {
      type: String,
      required: false,
      default: null,
    },
  },

  async created() {
    const params = {
      subscriptionTemplateId: this.subscriptionTemplateId,
      dataTransferAccepted: true,
      createCustomerOrderForm: false,
      customerSignatureObtained: false,
    };

    await subscriptionBegin(params);
  },
};
</script>
